'use client';

import {
  Active,
  DndContext,
  DragEndEvent,
  DragOverlay,
  DragStartEvent,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { useState } from 'react';
import { Box } from '@mantine/core';
import cloneNodeWithStyles from '@app/shared/helpers/cloneNodeWithStyles';
import { collisionDetection } from './utils/collisionDetection';
import { overlay } from './styles.css';

export default function ClientDndContext({
  children,
}: {
  children: React.ReactNode;
}) {
  const [activeElementState, setActiveElementState] = useState<Active | null>(
    null,
  );
  const element = activeElementState?.data.current?.element?.current as
    | HTMLElement
    | undefined;
  const clone = element
    ? cloneNodeWithStyles(element, { cursor: 'grabbing' })
    : undefined;

  const pointerSensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 4,
    },
  });

  const sensors = useSensors(pointerSensor);

  const onDragStart = ({ active }: DragStartEvent) => {
    setActiveElementState(active);
  };

  const onDragEnd = ({ over }: DragEndEvent) => {
    const onDrop = over?.data.current?.onDrop;
    if (over && typeof onDrop === 'function') {
      onDrop(activeElementState, over);
    }
    setActiveElementState(null);
  };

  return (
    <>
      <DndContext
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        sensors={sensors}
        collisionDetection={collisionDetection}
      >
        {children}

        <DragOverlay dropAnimation={null}>
          <Box
            className={overlay}
            dangerouslySetInnerHTML={{ __html: clone?.outerHTML ?? '' }}
          />
        </DragOverlay>
      </DndContext>
    </>
  );
}
